// from Highlight theme (component-toggle) -- Cette, updated for Cette Items

if (typeof CetteToggleTab !== 'function') {
  class CetteToggleTab extends HTMLElement {
    constructor() {
      super();

      this.titleEl = this.querySelector('[data-js-title]');
      this.contentEl = this.querySelector('[data-js-content]');
      this.titleEl.innerHTML = `${this.titleEl.innerHTML}${
        this.hasAttribute('data-togglepack-alternate')
          ? KROWN.settings.symbols.toggle_pack_alternate
          : KROWN.settings.symbols.toggle_pack
      }`;

      this.titleEl.addEventListener('click', this.onClickHandler.bind(this));
      this.titleEl.addEventListener('keydown', (e) => {
        if (e.keyCode == window.KEYCODES.RETURN) {
          this.onClickHandler();
        }
      });
    }

    updateImage() {
      // update selected image
      try {
        const imgs = this.closest('.cette-items')?.querySelector('[data-js-toggle-images]');
        const img = document?.getElementById(this.id?.replace('tog', 'img'));
        if (!imgs || !img) return;
        imgs.querySelectorAll('img').forEach((img) => img.classList.remove('active'));
        img.classList.add('active');
      } catch (err) {
        console.warn('error', err);
      }
    }

    closeToggle(toggle) {
      toggle.classList.remove('opened');
      toggle.titleEl.setAttribute('aria-expanded', 'false');
      toggle.slideUp(toggle.contentEl, 200);
    }

    closeAllToggles() {
      const toggles = this.closest('.cette-items')?.querySelectorAll('cette-toggle-tab');
      if (!toggles || !toggles.length) return;
      toggles.forEach((toggle) => {
        if (toggle !== this && toggle.classList.contains('opened')) {
          this.closeToggle(toggle);
        }
      });
    }

    onClickHandler() {
      if (!this.classList.contains('opened')) {
        this.closeAllToggles();
        this.classList.add('opened');
        this.updateImage();
        this.titleEl.setAttribute('aria-expanded', 'true');
        this.slideDown(this.contentEl, 200);
      } else {
        this.closeToggle(this);
      }
    }

    slideUp(target, duration) {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }
    slideDown(target, duration) {
      target.style.removeProperty('display');
      var display = window.getComputedStyle(target).display;

      if (display === 'none') display = 'block';

      target.style.display = display;
      var height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }
  }

  if (typeof customElements.get('cette-toggle-tab') == 'undefined') {
    customElements.define('cette-toggle-tab', CetteToggleTab);
  }
}

if (typeof ToggleGroup !== 'function') {
  class ToggleGroup extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('cette-toggle-tab').forEach((allToggle) => {
        allToggle.querySelector('[data-js-title]').addEventListener('click', () => {
          this.querySelectorAll('cette-toggle-tab.opened').forEach((openedToggle) => {
            if (allToggle !== openedToggle) {
              openedToggle.onClickHandler();
            }
          });
        });
      });
    }
  }

  if (typeof customElements.get('toggle-group') == 'undefined') {
    customElements.define('toggle-group', ToggleGroup);
  }
}
